import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem2,
    GridItem3xs4,
    GridItem3xs6,
    GridItem4xs6,
    GridItem6,
    GridItem6xs4,
    GridItem9xs6,
    GridItem10,
} from '../../../business-components/Grid/Grid'

import { 
    TextValidatorText,
    TextValidatorTextRequiredDestaque,
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorCpf,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
    atribuiDataIdade,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    SexoRadioGroupRequired
} from '../../../business-rules/RadioGroup/SexoRadioGroup'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import parentescoList from '../../../business-rules/List/parentescoList'

import {
    familiarPossuiDespesaReceita
} from './CadastroServiceFamiliares'

import {
    AvatarClienteConjugeFamiliar
} from './CadastroCompClienteConjugeFamiliares'



export const NomeFamiliar = ({ item, ind, handleChange }) => {

    return (
        <GridItem10>
            <TextValidatorTextRequiredDestaque
                name={`familiares[${ind}].nomeFamiliar`}
                placeholder={LABEL.nome}
                value={item.nomeFamiliar || ''}
                onChange={handleChange}
                tamMax={TAMMAX.nome}
            />
        </GridItem10>
    )
}

export const IconButtonClearEntradaDadosFamiliar = ({ values, item, ind, arrayHelpers }) => {

    let contatosAjustado = []

    return (
        <GridItem2>
            {!familiarPossuiDespesaReceita(values, item.familiar) && (
                <IconButtonClearEntradaDados
                    onClick={() => {
                        if (values.contatos) {
                            contatosAjustado = values.contatos.filter(contato => contato.familiar !== item.familiar)
                            values.contatos = contatosAjustado
                        }
                        arrayHelpers.remove(ind)
                    }}
                />
            )}
        </GridItem2>
    )
}

export const NascimentoFamiliar = ({ item, ind, setFieldValue }) => {

    return (
        <GridItem4xs6>
            <MuiPickersUtilsProviderPadrao>
                <KeyboardDatePickerPadrao
                    name={`familiares[${ind}].nascimentoFamiliar`}
                    label={LABEL.nascimento}
                    value={item.nascimentoFamiliar}
                    onChange={(date) => {
                        atribuiDataIdade(
                            setFieldValue,
                            date,
                            `familiares[${ind}].nascimentoFamiliar`,
                            `familiares[${ind}].idadeFamiliar`
                        )}
                    }
                />
            </MuiPickersUtilsProviderPadrao>
        </GridItem4xs6>
    )
}

export const IdadeFamiliar = ({ item, ind, handleChange }) => {

    return (
        <GridItem2>
            <TextValidatorNumberRequired
                name={`familiares[${ind}].idadeFamiliar`}
                label={LABEL.idade}
                value={item.idadeFamiliar === 0 ? 0 : item.idadeFamiliar || ''}
                onChange={handleChange}
                numMin={NUMMIN.idadeNascimento}
                numMax={NUMMAX.idade}
                disabled={item.nascimentoFamiliar ? true : false}
            />
        </GridItem2>
    )
}

export const SexoFamiliar = ({ item, ind, handleChange }) => {

    return (
        <GridItem3xs6>
            <SexoRadioGroupRequired
                name={`familiares[${ind}].sexoFamiliar`}
                value={item.sexoFamiliar || ''}
                onChange={handleChange}
            />
        </GridItem3xs6>
    )
}

export const ParentescoFamiliar = ({ item, ind, handleChange }) => {

    return (
        <GridItem3xs4>
            <TextFieldNumberSelectRequired
                name={`familiares[${ind}].parentescoFamiliar`}
                label={LABEL.parentesco}
                value={item.parentescoFamiliar || ''}
                onChange={handleChange}
                list={parentescoList(false)}
            />
        </GridItem3xs4>
    )
}

export const NomeCurtoFamiliar = ({ item, ind, handleChange }) => {

    return (
        <GridItem6>
            <TextValidatorText
                name={`familiares[${ind}].nomeCurtoFamiliar`}
                label={LABEL.nomeCurto}
                value={item.nomeCurtoFamiliar || ''}
                onChange={handleChange}
                tamMax={TAMMAX.nomeCurto}
            />
        </GridItem6>
    )
}

export const CpfFamiliar = ({ item, ind, handleChange }) => {

    return (
        <GridItem6>
            <TextValidatorCpf
                name={`familiares[${ind}].cpfFamiliar`}
                label={LABEL.cpf}
                value={item.cpfFamiliar || ''}
                onChange={handleChange}
            />
        </GridItem6>
    )
}

export const HerancaFamiliar = ({ values, item, ind, handleChange }) => {

    return (
        values.percMeacaoCliente
            ?
                <>
                    <CardGridDividerElementos/>
                    
                    <GridContainer>
                        {values.percHerancaFamiliarDiferenteConjuge
                            ?
                                <GridItem6xs4/>
                            :
                                <GridItem9xs6/>
                        }
                        <GridItem3xs4>
                            <TextValidatorNumber
                                name={`familiares[${ind}].percHerancaFamiliar`}
                                label={
                                    values.percHerancaFamiliarDiferenteConjuge
                                        ?
                                            LABEL.percHerancaCliente
                                        :
                                            LABEL.percHeranca
                                }
                                value={item.percHerancaFamiliar === 0 ? 0 : item.percHerancaFamiliar || ''}
                                onChange={handleChange}
                                numMin={NUMMIN.perc}
                                numMax={NUMMAX.perc}
                            />
                        </GridItem3xs4>
                        {values.percHerancaFamiliarDiferenteConjuge && (
                            <GridItem3xs4>
                                <TextValidatorNumber
                                    name={`familiares[${ind}].percHerancaFamiliarConjuge`}
                                    label={LABEL.percHerancaConjuge}
                                    value={item.percHerancaFamiliarConjuge === 0 ? 0 : item.percHerancaFamiliarConjuge || ''}
                                    onChange={handleChange}
                                    numMin={NUMMIN.perc}
                                    numMax={NUMMAX.perc}
                                />
                            </GridItem3xs4>
                        )}
                    </GridContainer>
                </>
            :
                ''
    )
}



export const AvatarFamiliar = ({ item, ind, setFieldValue }) => {

    return (
        <AvatarClienteConjugeFamiliar
            name={`familiares[${ind}].avatar`}
            value={item.avatar}
            setFieldValue={setFieldValue}
            sexo={item.sexoFamiliar}
        /> 
    )
}